import {CanMatchFn} from '@angular/router';

const allowedFixtureStates = new Set(['conversation-pointer']);
const allowedFixturePaths = new Set(['/ai/settings/client-settings']);

export function isClientSettingsVisualFixtureUrl(href: string): boolean {
  const url = new URL(href);
  const isLocalHost = ['localhost', '127.0.0.1', '[::1]', '::1'].includes(url.hostname);
  const fixtureState = url.searchParams.get('clientSettingsVisualFixture') || '';

  return isLocalHost && allowedFixturePaths.has(url.pathname) && allowedFixtureStates.has(fixtureState);
}

export const clientSettingsVisualFixtureCanMatch: CanMatchFn = () => {
  if (typeof window === 'undefined' || !window.location) return false;

  return isClientSettingsVisualFixtureUrl(window.location.href);
};
